var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { service } from '@ember/service';
import queryString from 'query-string';
import { waitForPromise } from '@ember/test-waiters';
let Fetch = (_class = class Fetch extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "iliosConfig", _descriptor2, this);
  }
  get authHeaders() {
    const headers = {};
    if (this.session && this.session.isAuthenticated) {
      const {
        jwt
      } = this.session.data.authenticated;
      if (jwt) {
        headers['X-JWT-Authorization'] = `Token ${jwt}`;
      }
    }
    return headers;
  }
  get host() {
    return this.iliosConfig.apiHost ? this.iliosConfig.apiHost : window.location.protocol + '//' + window.location.host;
  }
  apiHostUrlFromPath(relativePath) {
    const trimmedPath = relativePath.replace(/^\//, '');
    return `${this.host}/${trimmedPath}`;
  }
  async getJsonFromApiHost(relativePath) {
    const url = this.apiHostUrlFromPath(relativePath);
    const response = await waitForPromise(fetch(url, {
      headers: this.authHeaders
    }));
    return response.json();
  }
  async postToApiHost(relativePath, body, contentType) {
    const url = this.apiHostUrlFromPath(relativePath);
    const headers = this.authHeaders;
    headers['Content-Type'] = contentType;
    headers['Accept'] = 'application/vnd.api+json';
    const response = await waitForPromise(fetch(url, {
      method: 'POST',
      headers,
      body
    }));
    return response.json();
  }
  async postQueryToApi(path, data) {
    const apiPath = `/${this.iliosConfig.apiNameSpace}/${path}`;
    const body = queryString.stringify(data, {
      arrayFormat: 'bracket'
    });
    return this.postToApiHost(apiPath, body, 'application/x-www-form-urlencoded');
  }
  async postManyToApi(path, items) {
    const apiPath = `/${this.iliosConfig.apiNameSpace}/${path}`;
    const body = JSON.stringify({
      data: items
    });
    return this.postToApiHost(apiPath, body, 'application/vnd.api+json');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "iliosConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Fetch as default };